import { render, staticRenderFns } from "./TopicBg.vue?vue&type=template&id=4e25e655&scoped=true"
import script from "./TopicBg.vue?vue&type=script&lang=js"
export * from "./TopicBg.vue?vue&type=script&lang=js"
import style0 from "./TopicBg.vue?vue&type=style&index=0&id=4e25e655&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e25e655",
  null
  
)

export default component.exports